import { ServiceDeliveryRepository } from "../domain/ServiceDeliveryRepository";
import { Service} from "@/modules/revenue/domain/Service";

export class GetExtraUsersDataQuery {

    constructor(
        private readonly sd_repository: ServiceDeliveryRepository,
        private readonly screen_data,
    ) {}

    async execute(s: Service) {
        if (!s) return;

        const current = this.screen_data[s.kind];
        if (!current) return;
        
        // if (current.show && current.extra_users_price === s.extra_users_price) {
        //     this._reset(current);
        //     return;
        // }
        
        current.show = true;
        current.extra_users_num = 0;
        current.paid_extra_users = 0;
        current.selected_extra_users = 0;
        current.extra_users_price = s.extra_users_price;
        current.diff_extra = 0;
        current.validation_error = null;

        const sds = await this.sd_repository.find_by_criteria([[['service.kind', s.kind, '==']]], 'start_date', 'desc', 1);
        if (sds.length > 0) {
            current.show = true;
            const sd = sds[0];
            current.extra_users_num  = sd.users_num;
            const old_service_limit = sd.service.limit_users;
            const new_service_limit = s.limit_users;
            const current_paid_extra = sd.paid_extra_users || 0;
            const limit_difference = old_service_limit - new_service_limit;
            
            const recalculated_paid_extra = Math.max(current_paid_extra - (current.extra_users_num - new_service_limit), 0);
            if (current.extra_users_num  <= current_paid_extra) {
                current.paid_extra_users = current_paid_extra;
            } else {
                current.paid_extra_users = recalculated_paid_extra;
            }
            current.selected_extra_users = current.paid_extra_users;
            current.extra_users_price = s.extra_users_price;
            current.diff_extra = current.selected_extra_users - current.paid_extra_users;
        }
    }
    
    private _reset(current) {
        current.show = false;
        current.extra_users_num = null;
        current.paid_extra_users = null;
        current.selected_extra_users = null;
        current.extra_users_price = null;
        current.validation_error = null;
    }
}